/* Enter your Custom Javascript code below without script tag */
// Company name: Developed by TechFanatic 
// Website URL: https://techfanatic.in/

$( document ).ready(function() {
        
    jQuery(".footer-toggle").removeClass("footer-toggle")
    
        $('.card--standard .card__inner').each(function() {
            if ($(this).find('.altli').length !== 0) {
                $(this).find('.product_variant').css({
                    'display': 'flex',
                });
        } else {
                $(this).find('.product_variant').css({
                'display': 'none',
                });
        }
    });
        
    jQuery("#Details-menu-drawer-menu-item-1 > summary").click();
    
    jQuery("#Details-menu-drawer-submenu-2 > summary").click();
});